import { IconButton, MenuList, Paper, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ReactNode, useState } from "react";
import { ClickAwayListener } from "@mui/base";
import Iconify from "src/components/iconify";

type AppMenuOption = {
  onClick(): void;
  label: ReactNode;
};

type AppContextMenuButtonProps = {
  options: AppMenuOption[];
};

export default function AppContextMenuButton(props: AppContextMenuButtonProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    // Click-Away Listener
    // ref: https://mui.com/base/react-click-away-listener/
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <IconButton color={open ? 'inherit' : 'default'} onClick={handleClick}>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Stack direction="row" spacing={2}>
            <Paper>
              <MenuList
                autoFocusItem={open}
                id="composition-menu"
                aria-labelledby="composition-button"
              >
                {props.options.map((option) => {
                  return (
                    <MenuItem onClick={option.onClick}>{option.label}</MenuItem>
                  );
                })}
              </MenuList>
            </Paper>
          </Stack>
        </Menu>
      </div>
    </ClickAwayListener>
  );
}
